module.exports = __webpack_public_path__ + "img/icon10.99977478.png";